import { SCREEN_SM } from "@/style/breakpoints";

/**
 * Detects the React Native WebView of the mobile app. Takes the user agent
 * as an argument so it can run on the server against the request header.
 * The string originates from MOBILE_UA_SUFFIX in apps/mobile/src/config.ts.
 * */
export function isMobileWebViewUserAgent(userAgent: string | null | undefined): boolean {
  return !!userAgent?.includes("CorcaMobile");
}

export function getIsMobile() {
  return (
    typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    window.innerWidth <= SCREEN_SM &&
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
    /(mobile)/i.test(navigator.userAgent)
  );
}
